<template>
    <date-picker v-bind="[$props,$attrs]" v-on="$listeners" :format="format" :value-type="valueType" range-separator=" - ">
        <template #icon-calendar>
            <span class="material-icons-outlined">
            event
            </span>
        </template>
        <template #icon-clear>
            <span class="material-icons-outlined">
            clear
            </span>
        </template>
    </date-picker>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import '@core/scss/vue/libs/date-picker.scss'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/tr';
export default {
    components:{
        DatePicker
    },
    props:{
        onlyHour:{
            type:Boolean,
            default:false
        },
        withSeconds:{
            type:Boolean,
            default:false
        },
        forBack:{
            type:Boolean,
            default:false
        }
    },
    computed:{
        format(){
            if(this.$attrs['type'] == 'time'){
                if(this.onlyHour) return "HH"
                else if(this.withSeconds) return "HH:mm:ss"
                else return "HH:mm"
            }else if(this.$attrs['type'] == 'datetime'){
                return 'DD.MM.YYYY HH:mm'
            }else if (this.$attrs['type'] == 'month'){
                return 'YYYY MMMM'
            }
            else return "DD.MM.YYYY"
        },
        valueType(){
            if(this.$attrs['type'] == 'time'){
                if(this.onlyHour) return "HH"
                else if(this.withSeconds) return "HH:mm:ss"
                else return "HH:mm"
            } else if(this.$attrs['type'] == 'datetime'){
                if(this.forBack){
                    return 'YYYY-MM-DDTHH:mm:ss'
                }
                return 'YYYY-MM-DD HH:mm'
            }else if(this.$attrs['type'] == 'month'){
                return 'YYYY-MM'
            }
            else return "YYYY-MM-DD"
        }
    }
}
</script>

<style lang="scss">

</style>